import _ from 'lodash'
import { Map } from 'immutable'

import { TOOLBAR_ICON_CLICK, TOOLBAR_OUTSIDE_CLICK } from './constants'
import { TABS_TAB_REMOVED } from '../Tabs/constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case TABS_TAB_REMOVED: {
            const tabId = _.get(action, 'data.id', null)
            const module = _.get(action, 'data.type', null)

            return state.remove(`${module}_${tabId}`)
        }

        case TOOLBAR_ICON_CLICK: {
            const id = _.get(action, 'data.id', null)
            const name = _.get(action, 'data.name', null)

            const isActive = state.getIn([id, 'desks', name], false)
            const desks = state
                .getIn([id, 'desks'], Map())
                .map(() => false)
                .set(name, !isActive)

            return state.setIn([id, 'desks'], desks)
        }

        case TOOLBAR_OUTSIDE_CLICK: {
            const id = _.get(action, 'data.uniqueId', null)

            const desks = state.getIn([id, 'desks'], Map()).map(() => false)

            return state.setIn([id, 'desks'], desks)
        }

        default:
            return state
    }
}
